module.exports = __webpack_public_path__ + "static/hipotermia-a0fd57d643bcd4ca99f5649fdf4139ca.jpg";